import baseService from './baseService';

export function linkedInImport(data) {
  const config = { headers: { 'Content-Type': 'multipart/form-data' } };
  return baseService.post(`/linkedin_imports`, data, config);
}

export function sendLinkedInImportEmail() {
  return baseService.get(`/linkedin_imports/send_email`);
}

export function getLinkedinData(url) {
  return baseService.get('member/linkedin_profile_import', {
    params: {
      linkedin_url: url,
      profile: 'company',
    },
  });
}
